import { h } from 'preact';
import PropTypes from 'prop-types';
import React from 'react';

const Slide = props => (
  <div {...props} style={{ ...props.style, height: props.height }}>
    {props.children}
  </div>
);

Slide.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  height: PropTypes.string,
};

Slide.defaultProps = {
  children: null,
  style: {},
  height: window.innerHeight,
};

Slide.isSlideOfFullpage = true;

export default Slide;



// WEBPACK FOOTER //
// ./src/components/Fullpage/Slide.jsx